import { useMemo } from "react";
import type { LayoutObject } from "@stripe/stripe-js";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { stripeElementsPaymentElementLayoutTypes } from "../../../StripeElements/types";

export const usePaymentElementLayout = (): LayoutObject => {
  const { isPaywallsCheckoutCustomizationPhase1Enabled } =
    usePaywallCheckoutContext();

  return useMemo(
    () => ({
      type: stripeElementsPaymentElementLayoutTypes.accordion,
      radios: isPaywallsCheckoutCustomizationPhase1Enabled,
    }),
    [isPaywallsCheckoutCustomizationPhase1Enabled],
  );
};
